import React from "react";
import {
  Home,
  Upload,
  Image as ImageIcon,
  Film,
  Music,
  Subtitles,
  Type,
  Shapes,
  Shuffle,
  Sparkles,
  Layers,
  Filter
} from "lucide-react";

const items = [
  // { id: "upload", label: "Upload", icon: Upload },
  { id: "home", label: "Home", icon: Home },
  { id: "image", label: "Image", icon: ImageIcon },
  { id: "video", label: "Video", icon: Film },
  { id: "audio", label: "Audio", icon: Music },
  { id: "subtitles", label: "Subtitles", icon: Subtitles },
  { id: "text", label: "Text", icon: Type },
  { id: "elements", label: "Elements", icon: Shapes },
  { id: "transition", label: "Transitions", icon: Shuffle },
  { id: "animation", label: "animation", icon: Sparkles },
  { id: "keyframe", label: "keyframe", icon: Layers },
  { id: "filter", label: "Filters", icon: Filter },
];

export default function LeftSidebar({ active = "home", onChange, videos = [], onSelect }) {
  return (
    <aside className="
      w-16 rounded-lg p-2 flex flex-col items-center gap-2
      bg-gray-100 text-gray-700
      dark:bg-gray-900 dark:text-gray-300
      border border-gray-200 dark:border-gray-800
      transition-colors
    ">
      {items.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onChange(id)}
          className={`flex items-center gap-3 px-3 py-2 rounded-md transition 
            ${active === id ? "bg-gray-400 text-white"
                            : "hover:bg-gray-300 dark:hover:bg-gray-800"}
            `}
          title={label}>
          <Icon size={18} />
        </button>
      ))}
    </aside>
  );
}